// Desktop notifications for team chat (only once the agent turned them on)
export const notificationsSupported = () => 'Notification' in window;

export const notificationsEnabled = () =>
  notificationsSupported() && window.Notification.permission === 'granted';

export const requestNotifications = () =>
  notificationsSupported()
    ? window.Notification.requestPermission()
    : Promise.resolve('denied');

export const showChatNotification = t => (channel, message) => {
  if (!notificationsEnabled()) return;
  const notification = new window.Notification(
    t('LOCO.CHAT.NOTIFICATION_TITLE', {
      sender: message.sender?.name || '',
      channel: channel.name,
    }),
    {
      body: (message.content || '').slice(0, 140),
      tag: `loco-chat-${channel.id}`,
    }
  );
  notification.onclick = () => {
    window.focus();
    const accountId = window.location.pathname.split('/')[3];
    window.location.assign(
      `/app/accounts/${accountId}/team-chat/${channel.id}`
    );
  };
};
